module.exports = __webpack_public_path__ + "static/media/fire-alt.aa89630e.svg";